/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Cross_Title5Inputs */

const en_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cross-platform builds`)
};

const ar_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناء متعدد المنصات`)
};

const bn_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্রস-প্ল্যাটফর্ম বিল্ড`)
};

const de_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformübergreifende Builds`)
};

const es_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones multiplataforma`)
};

const fr_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions multiplateformes`)
};

const pt_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilações multiplataforma`)
};

const zh_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跨平台构建`)
};

const tr_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformlar arası derlemeler`)
};

const ru_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кроссплатформенные сборки`)
};

const pl_svc_mobile_app_development_cross_title5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacje wieloplatformowe`)
};

/**
* | output |
* | --- |
* | "Cross-platform builds" |
*
* @param {Svc_Mobile_App_Development_Cross_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_cross_title5 = /** @type {((inputs?: Svc_Mobile_App_Development_Cross_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Cross_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "de") return de_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "es") return es_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_cross_title5(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_cross_title5(inputs)
	return en_svc_mobile_app_development_cross_title5(inputs)
});
export { svc_mobile_app_development_cross_title5 as "svc_mobile-app-development_CROSS_title" }